import _objectWithoutProperties from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == typeof f && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(typeof r + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, catch: function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
import { parseByteRanges, parseContentRange, parseContentType } from './httputils';
import { BaseSource } from './basesource';
import { BlockedSource } from './blockedsource';
import { FetchClient } from './client/fetch';
import { XHRClient } from './client/xhr';
import { HttpClient } from './client/http';
var RemoteSource = /*#__PURE__*/function (_BaseSource) {
  _inherits(RemoteSource, _BaseSource);
  /**
   *
   * @param {BaseClient} client
   * @param {object} headers
   * @param {numbers} maxRanges
   * @param {boolean} allowFullFile
   */
  function RemoteSource(client, headers, maxRanges, allowFullFile) {
    var _this;
    _classCallCheck(this, RemoteSource);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(RemoteSource).call(this));
    _this.client = client;
    _this.headers = headers;
    _this.maxRanges = maxRanges;
    _this.allowFullFile = allowFullFile;
    _this._fileSize = null;
    return _this;
  }

  /**
   *
   * @param {Slice[]} slices
   */
  _createClass(RemoteSource, [{
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(slices, signal) {
        var _this2 = this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.maxRanges >= slices.length)) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", this.fetchSlices(slices, signal));
            case 4:
              if (this.maxRanges > 0 && slices.length > 1) {
                // TODO: split into multiple multi-range requests

                // const subSlicesRequests = [];
                // for (let i = 0; i < slices.length; i += this.maxRanges) {
                //   subSlicesRequests.push(
                //     this.fetchSlices(slices.slice(i, i + this.maxRanges), signal),
                //   );
                // }
                // return (await Promise.all(subSlicesRequests)).flat();
              }
            case 5:
              return _context.abrupt("return", Promise.all(slices.map(function (slice) {
                return _this2.fetchSlice(slice, signal);
              })));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
  }, {
    key: "fetchSlices",
    value: function () {
      var _fetchSlices = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(slices, signal) {
        var _this3 = this;
        var response, _parseContentType, type, params, byteRanges, data, _parseContentRange, start, end, total, first, others, _data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.client.request({
                headers: _objectSpread({}, this.headers, {
                  Range: "bytes=".concat(slices.map(function (_ref) {
                    var offset = _ref.offset,
                      length = _ref.length;
                    return "".concat(offset, "-").concat(offset + length);
                  }).join(','))
                }),
                signal: signal
              });
            case 2:
              response = _context2.sent;
              if (response.ok) {
                _context2.next = 7;
                break;
              }
              throw new Error('Error fetching data.');
            case 7:
              if (!(response.status === 206)) {
                _context2.next = 32;
                break;
              }
              _parseContentType = parseContentType(response.getHeader('content-type')), type = _parseContentType.type, params = _parseContentType.params;
              if (!(type === 'multipart/byteranges')) {
                _context2.next = 18;
                break;
              }
              _context2.t0 = parseByteRanges;
              _context2.next = 13;
              return response.getData();
            case 13:
              _context2.t1 = _context2.sent;
              _context2.t2 = params.boundary;
              byteRanges = (0, _context2.t0)(_context2.t1, _context2.t2);
              this._fileSize = byteRanges[0].fileSize || null;
              return _context2.abrupt("return", byteRanges);
            case 18:
              _context2.next = 20;
              return response.getData();
            case 20:
              data = _context2.sent;
              _parseContentRange = parseContentRange(response.getHeader('content-range')), start = _parseContentRange.start, end = _parseContentRange.end, total = _parseContentRange.total;
              this._fileSize = total || null;
              first = [{
                data: data,
                offset: start,
                length: end - start
              }];
              if (!(slices.length > 1)) {
                _context2.next = 29;
                break;
              }
              _context2.next = 27;
              return Promise.all(slices.slice(1).map(function (slice) {
                return _this3.fetchSlice(slice, signal);
              }));
            case 27:
              others = _context2.sent;
              return _context2.abrupt("return", first.concat(others));
            case 29:
              return _context2.abrupt("return", first);
            case 32:
              if (this.allowFullFile) {
                _context2.next = 34;
                break;
              }
              throw new Error('Server responded with full file');
            case 34:
              _context2.next = 36;
              return response.getData();
            case 36:
              _data = _context2.sent;
              this._fileSize = _data.byteLength;
              return _context2.abrupt("return", [{
                data: _data,
                offset: 0,
                length: _data.byteLength
              }]);
            case 39:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchSlices(_x3, _x4) {
        return _fetchSlices.apply(this, arguments);
      }
      return fetchSlices;
    }()
  }, {
    key: "fetchSlice",
    value: function () {
      var _fetchSlice = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(slice, signal) {
        var offset, length, response, data, _parseContentRange2, total, _data2;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              offset = slice.offset, length = slice.length;
              _context3.next = 3;
              return this.client.request({
                headers: _objectSpread({}, this.headers, {
                  Range: "bytes=".concat(offset, "-").concat(offset + length)
                }),
                signal: signal
              });
            case 3:
              response = _context3.sent;
              if (response.ok) {
                _context3.next = 8;
                break;
              }
              throw new Error('Error fetching data.');
            case 8:
              if (!(response.status === 206)) {
                _context3.next = 17;
                break;
              }
              _context3.next = 11;
              return response.getData();
            case 11:
              data = _context3.sent;
              _parseContentRange2 = parseContentRange(response.getHeader('content-range')), total = _parseContentRange2.total;
              this._fileSize = total || null;
              return _context3.abrupt("return", {
                data: data,
                offset: offset,
                length: length
              });
            case 17:
              if (this.allowFullFile) {
                _context3.next = 19;
                break;
              }
              throw new Error('Server responded with full file');
            case 19:
              _context3.next = 21;
              return response.getData();
            case 21:
              _data2 = _context3.sent;
              this._fileSize = _data2.byteLength;
              return _context3.abrupt("return", {
                data: _data2,
                offset: 0,
                length: _data2.byteLength
              });
            case 24:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchSlice(_x5, _x6) {
        return _fetchSlice.apply(this, arguments);
      }
      return fetchSlice;
    }()
  }, {
    key: "fileSize",
    get: function get() {
      return this._fileSize;
    }
  }]);
  return RemoteSource;
}(BaseSource);
function maybeWrapInBlockedSource(source, _ref2) {
  var blockSize = _ref2.blockSize,
    cacheSize = _ref2.cacheSize;
  if (blockSize === null) {
    return source;
  }
  return new BlockedSource(source, blockSize, cacheSize);
}
export function makeFetchSource(url) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref3$headers = _ref3.headers,
    headers = _ref3$headers === void 0 ? {} : _ref3$headers,
    credentials = _ref3.credentials,
    _ref3$maxRanges = _ref3.maxRanges,
    maxRanges = _ref3$maxRanges === void 0 ? 0 : _ref3$maxRanges,
    _ref3$allowFullFile = _ref3.allowFullFile,
    allowFullFile = _ref3$allowFullFile === void 0 ? false : _ref3$allowFullFile,
    blockOptions = _objectWithoutProperties(_ref3, ["headers", "credentials", "maxRanges", "allowFullFile"]);
  var client = new FetchClient(url, credentials);
  var source = new RemoteSource(client, headers, maxRanges, allowFullFile);
  return maybeWrapInBlockedSource(source, blockOptions);
}
export function makeXHRSource(url) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref4$headers = _ref4.headers,
    headers = _ref4$headers === void 0 ? {} : _ref4$headers,
    _ref4$maxRanges = _ref4.maxRanges,
    maxRanges = _ref4$maxRanges === void 0 ? 0 : _ref4$maxRanges,
    _ref4$allowFullFile = _ref4.allowFullFile,
    allowFullFile = _ref4$allowFullFile === void 0 ? false : _ref4$allowFullFile,
    blockOptions = _objectWithoutProperties(_ref4, ["headers", "maxRanges", "allowFullFile"]);
  var client = new XHRClient(url);
  var source = new RemoteSource(client, headers, maxRanges, allowFullFile);
  return maybeWrapInBlockedSource(source, blockOptions);
}
export function makeHttpSource(url) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref5$headers = _ref5.headers,
    headers = _ref5$headers === void 0 ? {} : _ref5$headers,
    _ref5$maxRanges = _ref5.maxRanges,
    maxRanges = _ref5$maxRanges === void 0 ? 0 : _ref5$maxRanges,
    _ref5$allowFullFile = _ref5.allowFullFile,
    allowFullFile = _ref5$allowFullFile === void 0 ? false : _ref5$allowFullFile,
    blockOptions = _objectWithoutProperties(_ref5, ["headers", "maxRanges", "allowFullFile"]);
  var client = new HttpClient(url);
  var source = new RemoteSource(client, headers, maxRanges, allowFullFile);
  return maybeWrapInBlockedSource(source, blockOptions);
}

/**
 *
 * @param {string} url
 * @param {object} options
 */
export function makeRemoteSource(url) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref6$forceXHR = _ref6.forceXHR,
    forceXHR = _ref6$forceXHR === void 0 ? false : _ref6$forceXHR,
    clientOptions = _objectWithoutProperties(_ref6, ["forceXHR"]);
  if (typeof fetch === 'function' && !forceXHR) {
    return makeFetchSource(url, clientOptions);
  }
  if (typeof XMLHttpRequest !== 'undefined') {
    return makeXHRSource(url, clientOptions);
  }
  return makeHttpSource(url, clientOptions);
}